function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-329.684 -496.751)"
}, React.createElement("path", {
  className: "path",
  d: "M17.333,44.779,34.719,34.741a.881.881,0,0,0,0-1.526L17.333,23.174a.881.881,0,0,0-1.322.763v4.674H1a.882.882,0,0,0-.881.881V38.46A.882.882,0,0,0,1,39.341H16.011v4.674a.883.883,0,0,0,1.322.765Z",
  transform: "translate(364.843 551.809) rotate(180)"
}), React.createElement("path", {
  className: "path",
  d: "M56.867,0H38.907a.882.882,0,0,0-.881.881V3.526a.882.882,0,0,0,.881.881h17.96a2.105,2.105,0,0,1,2.1,2.1V35.654a2.105,2.105,0,0,1-2.1,2.1H38.907a.882.882,0,0,0-.881.881v2.644a.882.882,0,0,0,.881.881h17.96a6.517,6.517,0,0,0,6.51-6.51V6.511A6.518,6.518,0,0,0,56.867,0Z",
  transform: "translate(318.364 496.751)"
}));

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 52.058,
    height: 42.164,
    viewBox: "0 0 52.058 42.164",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.ae4d50fa.svg";
export { ForwardRef as ReactComponent };